<template>
  <div class="pagination" v-if="pagination && pagination.total_pages > 1">
    <ul class="pagination__Pages">
      <li class="pagination__item" v-if="pagination.page_number > 1">
        <button type="button" class="btn btn--primary btn--small" @click="loadResource(pagination.page_number - 1)">&lt;</button>
      </li>

      <template v-if="pagination.page_number > showPages">
        <li class="pagination__item"><button type="button" class="btn btn--primary btn--small" @click="loadResource(1)" :class="{ 'btn--danger': pagination.page_number === 1 }">1</button></li>
        <li class="pagination__item"><span>...</span></li>
      </template>
      <li class="pagination__item" v-for="n in pagination.total_pages" :key="n.id" v-if="n < pagination.page_number + showPages && n > pagination.page_number - showPages"><button type="button" class="btn btn--primary btn--small" @click="loadResource(n)" :class="{ 'btn--danger': pagination.page_number === n }">{{ n }}</button></li>
      <template v-if="pagination.page_number + (showPages - 1) < pagination.total_pages">
        <li class="pagination__item"><span>...</span></li>
        <li class="pagination__item"><button type="button" class="btn btn--primary btn--small" @click="loadResource(pagination.total_pages)" :class="{ 'btn--danger': pagination.page_number === pagination.total_pages }">{{ pagination.total_pages }}</button></li>
      </template>

      <li class="pagination__item" v-if="pagination.page_number < pagination.total_pages">
        <button type="button" class="btn btn--primary btn--small" @click="loadResource(pagination.page_number + 1)">&gt;</button>
      </li>
    </ul>
  </div>
</template>

<script>
import {loadResource} from '@/helpers/resource'

export default {
  props: {
    Resource: {
      required: true
    },
    type: {
      required: true
    },
    pagination: {
      required: true
    },
    isLoading: {
      required: true
    },
    pageSize: {
      default: 10
    },
    customParams: {
      default: false
    },
    showPages: {
      default: 3
    }
  },
  methods: {
    loadResource (n) {
      if (this.customParams) {
        loadResource(this.Resource, this.type, this.isLoading, {page: n, page_size: this.pageSize, ...this.customParams})
      } else {
        loadResource(this.Resource, this.type, this.isLoading, {page: n, page_size: this.pageSize})
      }
    }
  }
}
</script>

<style lang="stylus">
@import '../../assets/stylus/general/_variables'

.pagination
  background #fff

  &__Pages
    margin 0
    padding: 1rem
    text-align center
    list-style none

  &__item
    display inline-block
    margin .5rem .2rem
</style>



// WEBPACK FOOTER //
// src/components/Utils/Pagination.vue